import { createRef, createElement, Component } from 'react';
import { node, bool, string } from 'prop-types';
import { sizePropType } from '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { f as _defineProperty, e as _inheritsLoose, g as _assertThisInitialized, b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import _Badge from './styled.js';

var badgePropTypes = {
  children: node,
  isAbsolute: bool,
  palette: string,
  size: sizePropType
};
var badgeDefaultProps = {
  children: undefined,
  isAbsolute: false,
  palette: 'text',
  size: 'default'
};
var Badge =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Badge, _React$Component);

  function Badge() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "badge", createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      parentElement: undefined
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var parentElement = _get(_this.badge, 'current.parentElement');

      parentElement.setAttribute('style', 'position:relative;');

      _this.setState({
        parentElement: parentElement
      });
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          size = _this$props.size,
          props = _objectWithoutPropertiesLoose(_this$props, ["children", "size"]);

      return createElement(_Badge, _extends({
        elementRef: _this.badge,
        styledSize: size
      }, props), children);
    });

    return _this;
  }

  return Badge;
}(Component); // @ts-ignore

_defineProperty(Badge, "propTypes", badgePropTypes);

_defineProperty(Badge, "defaultProps", badgeDefaultProps);

var C = Badge;

export default C;
export { C as Badge, badgeDefaultProps, badgePropTypes };
